enum DomainStatusTypeEnum {
  Pending = 0,
  Verified = 1,
  Broken = 2,
}

export default DomainStatusTypeEnum;
